<template>
  <div>
    <Dialog
      :visible.sync="reminderTypeForm1"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Reminder Type Details"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="reminderTypeCode">Type Code*</label>
          <InputText
            id="reminderTypeCode"
            v-model.trim="reminderType.reminderTypeCode"
            required="true"
            autofocus
            :class="{
              'p-invalid': submitted && !reminderType.reminderTypeCode
            }"
            :disabled="disabledArr.includes('reminderTypeCode')"
          />
          <small
            class="p-invalid"
            v-if="submitted && !reminderType.reminderTypeCode"
            >reminderType Code is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="lastName">Mark Active</label>
          <SelectButton
            v-model="reminderType.active"
            :options="options"
            optionLabel="name"
          />
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="reminderTypeName">Type Name*</label>
          <InputText
            id="reminderTypeName"
            v-model.trim="reminderType.reminderTypeName"
            required="true"
            autofocus
            :class="{
              'p-invalid': submitted && !reminderType.reminderTypeName
            }"
            :disabled="disabledArr.includes('reminderTypeName')"
          />
          <small
            class="p-invalid"
            v-if="submitted && !reminderType.reminderTypeName"
            >reminderType Code is required.</small
          >
        </div>
      </div>

      <template #footer>
        <Button
          label="Reset"
          icon="pi pi-refresh"
          class="p-button-text"
          @click="reset"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="cancel"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  props: ["reminderTypeToEdit", "reminderTypeForm", "disabledArr"],
  data: () => ({
    reminderType: {},
    submitted: false,
    options: [
      { name: "Active", value: true },
      { name: "Inactive", value: false }
    ]
  }),
  created() {
    if (this.reminderTypeToEdit && this.reminderTypeToEdit.id) {
      this.reminderType = { ...this.reminderTypeToEdit };
      this.reminderTypeToEdit.active
        ? (this.reminderType.active = { name: "Active", value: true })
        : (this.reminderType.active = { name: "Inactive", value: false });
    }
  },
  computed: {
    reminderTypeForm1: {
      set(val) {
        if (!val) {
          this.cancel();
        }
      },
      get() {
        return this.reminderTypeForm ? true : false;
      }
    }
  },
  methods: {
    reset() {
      this.reminderType = {};
    },
    save() {
      this.submitted = true;

      if (
        this.reminderType.reminderTypeCode &&
        this.reminderType.reminderTypeName
      ) {
        if (this.reminderType.active instanceof Object) {
          this.reminderType.active = this.reminderType.active.value;
        }

        this.$emit("save", this.reminderType);
      }
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style></style>
